import * as actionTypes from '../../constants/action-types/auth';

const INIT_STATE = {
    user: null,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case actionTypes.RECEIVE_USER:
            return {...state, user: action.payload.user};

        case actionTypes.RECEIVE_STUDENT:
            return {...state, user: {...state.user, student: action.payload.student}};

        case actionTypes.LOGOUT_SUCCESS:
            return {...state, user: null};

        default:
            return {...state};
    }
};
